




















import { Component, Vue } from 'vue-property-decorator';
import { Tabs } from 'thsc-hxmui';
import { tabsList } from './common/config';
import { ITbasList } from '../../common/models/index-app';
import { removeIosBounce } from '../../common/utils/utils';
import { getServeDate } from './service/index';
import { shareUrlCard, callShare } from '../../common/utils/share';
import { tabsListMaidianConfig } from './common/maidianConfig';
import NoticeBar from './components/NoticeBar/index.vue'
import BackWash from '../../components/backWash/index.vue';
import { setPageTitle } from './common/utils';
import { getRootViewClass, isJiaoYi } from './common/sourceConfig';

const win: any = window;
const { hxmClickStat } = win;
const { isBlackMode } = win.F10Utils;

Vue.use(Tabs);
@Component({
  components: {
    Tabs,
    NoticeBar,
    BackWash,
  }
})
export default class App extends Vue {
  public $hxmui: any
  public $route: any;
  public $router: any;
  private date: any = {};
  private tabsList: ITbasList[] = tabsList; // 渲染tabs组件的默认数据
  private defaultTab = '';
  private isShowTab = !Number(win.F10Utils.getUrlParams('isNotShowTab'));
  private lastTime = 0; // 最近一次点击时间
  private isShare = !win.F10Utils.getBroker();
  private pageClassName = getRootViewClass();
  private async created() {
    if(isJiaoYi){
      win.hxmPageStat('free_ipojy', {});
    }else{
      win.hxmPageStat('free_ipo', {});
    }
    // 去掉ios弹性下拉
    removeIosBounce();
    // 添加分享功能
    shareUrlCard();
    // 设置当前默认选中的tab 不设置非第一个tab出去hxm-tabs选中的tab不正确
    this.defaultTab = this.getNowHash(this.tabsList);
    if (!this.isShowTab && isBlackMode()) {
      this.$hxmui.theme = 'black';
    }
  }

  private mounted() {
    this.setTitle();
    this.setShareImg();
    // 解决安卓跳转到其他页面引起的分享问题
    win.registerWebListener("onShow", function () {
      win.callNativeHandler("changeWebViewButton", "");
      win.registerWebHandler("changeWebViewButton", (data: any) => {
        callShare();
      })
    });
    // 网页中禁止双击缩放页面
    if(this.isShare) {
      this.handleIosScale();
    }
  }

  private setTitle() {
    const url = location.href;
    if (url.indexOf('hkStock') > -1 && url.indexOf('isNotShowTab=1') > -1) {
      setPageTitle('港股打新');
    } else {
      setPageTitle('打新日历');
    }
  }

  private setShareImg() {
    win.callNativeHandler('notifyWebHandleEvent', {
      'method': 'setTitleBar',
      'params': {
        'rightViewType': 'ShareImageView', //右上角功能的类型
        'stopSetNil': 'yes',//显示右上角按钮
      }
    });
  }

  private handleIosScale() {
    document.addEventListener('touchstart', (e: any) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    });
    document.addEventListener('touchend', (e: any) => {
      const nowTime = (new Date()).getTime();
      if (nowTime - this.lastTime <= 300) {
        e.preventDefault();
      }
      this.lastTime = nowTime;
    }, false);
    document.addEventListener('gesturestart', (e: any) => {
      e.preventDefault();
    });
  }

  private updated() {
    this.defaultTab = this.getNowHash(this.tabsList);
  }

  /**
   * 获取当前选中tab的名称
   * @param { string } list tab列表数据
   */
  private getNowHash(list: any[]) {
    let name = '';
    list.forEach((item: any)=>{
      if(win.location.hash.indexOf(item.name) > -1) {
        name = item.name;
      }
    });
    if (!name) {
      return list[0].name;
    }
    return name;
  }

  /**
   * 处理tabs切换
   * @param { string } name 当前点击tab的名称
   */
  private handleClick(name: any) {
    // 埋点
    hxmClickStat(`free_ipo.${tabsListMaidianConfig[name]}`);
    // 跳转
    this.$router.push({
      path: name,
      query: {...this.$route.query}
    })
  }
}
